import React, { Component } from 'react';
import Grid from "@mui/material/Grid";
import Switch from '../../../components/Switch.js';
import Bubble from '../../../components/Bubble.js';
import BubbleSelectBlock from '../../../components/BubbleSelectBlock.js';
import NumberInput from '../../../components/TextFields/NumberInput.js';
import Text from '../../../components/Text.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import BlockContent from '../../../components/BlockContent.js';
import HeaderDiv from '../../../components/HeaderDiv.js';
import { colors } from '../../../theme/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import { selectFieldOptions } from '../../../services/index.js';
import * as localizationMaps from '../../../localization/maps.js';
class SpendingAccounts extends Component {
  state = {
    data: null
  };
  componentDidMount() {
    const defaults = this._setData(this.props.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, this.props.tier, 'health', 'spendingAccounts', defaults);
      return;
    }

    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'spendingAccounts', defaults);
  }
  componentDidUpdate(prevProps) {
    const {
      data,
      revision,
      type,
      selectedDesignID,
      savePlanDesignBenefitInitData,
      selectedClassID
    } = this.props;

    // Check if specific props have changed to avoid unnecessary updates
    if (data !== prevProps.data || revision !== prevProps.revision || type !== prevProps.type || selectedDesignID !== prevProps.selectedDesignID) {
      const defaults = this._setData(data);

      // we are viewing a revision so we don't need to set data in state
      if (revision || type === "modular") {
        return;
      }
      if (selectedDesignID !== prevProps.selectedDesignID) {
        // save the init data in global state so it's there for the save
        savePlanDesignBenefitInitData(selectedClassID, selectedDesignID, 'spendingAccounts', defaults);
      }
    }
  }
  _setData = data => {
    const defaults = {
      isSelected: data.isSelected || false,
      isPooled: data.isPooled || false,
      // allow the user to set their own amounts using the pooled amount
      includeHsa: data.includeHsa || false,
      hsaAmount: data.hsaAmount || 0,
      allowHsaRollover: data.allowHsaRollover || 'Yes',
      setMaxHsaRollover: data.setMaxHsaRollover || 'No',
      maxHsaRollover: data.maxHsaRollover || 0,
      includeLsa: data.includeLsa || false,
      lsaAmount: data.lsaAmount || 0,
      allowLsaRollover: data.allowLsaRollover || 'Yes',
      setMaxLsaRollover: data.setMaxLsaRollover || 'No',
      maxLsaRollover: data.maxLsaRollover || 0,
      pooledAmountAvailable: data.pooledAmountAvailable || 0,
      allowPooledAmountRollover: data.allowPooledAmountRollover || 'Yes',
      setMaxPooledRollover: data.setMaxPooledRollover || 'No',
      terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
      eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
      minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
      isQuarterlyAllowance: data.isQuarterlyAllowance || false,
      isProrated: data.isProrated || false,
      proratedBy: data.proratedBy || 'day',
      // day, month or quarter
      notes: data.notes || null
    };
    this.setState({
      data: {
        ...defaults
      }
    });
    return defaults;
  };
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        [field]: value
      }
    });
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'isProrated' && value === true) {
      this._saveInGlobalState('isQuarterlyAllowance', false);
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, this.props.tier, 'health', 'spendingAccounts', field, value);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'spendingAccounts', field, value);
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      errors,
      whitelabel,
      revision,
      isRevisionBlock,
      lightTierColor,
      darkTierColor
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    const tierLabelStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 90,
      padding: 5,
      marginRight: 10,
      backgroundColor: lightTierColor
    };
    return /*#__PURE__*/React.createElement(BlockContent, {
      style: isRevisionBlock ? {
        backgroundColor: '#F7F9FA'
      } : null
    }, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `${i18n.t(tokens.titles.SpendingAccounts)} (${revision.revisionID})` : i18n.t(tokens.labels.planDesign.spendingAccountsCurrent) : i18n.t(tokens.titles.spendingAccounts)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        flex: 1
      }
    }, this.props.tier && /*#__PURE__*/React.createElement("div", {
      style: tierLabelStyle
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: darkTierColor
    }, this.props.tier.toUpperCase())), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    }))), isSelected && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.combineHealthLifestyleSpendingMaximums)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.buttons.yes),
        selected: data.isPooled === true,
        field: 'isPooled'
      },
      second: {
        title: i18n.t(tokens.buttons.no),
        selected: data.isPooled === false,
        field: 'isPooled'
      },
      handleChange: () => this._saveInGlobalState('isPooled', !data.isPooled)
    }), data.isPooled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.healthLifestyleSpendingMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.pooledAmountAvailable,
      onChange: e => this._handleChange("pooledAmountAvailable", e.target.value),
      onBlur: e => this._saveInGlobalState("pooledAmountAvailable", e.target.value),
      error: errors.pooledAmountAvailable,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.allow1YearRollover),
      fullWidth: true,
      value: localizationMaps.fromEnglish('yesOrNo', data.allowPooledAmountRollover),
      variant: "outlined",
      error: errors.allowPooledAmountRollover,
      onChange: e => this._handleChange("allowPooledAmountRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      onBlur: e => this._saveInGlobalState("allowPooledAmountRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.yesOrNo()
    })), data.allowPooledAmountRollover === 'Yes' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.setRolloverMaximum),
      fullWidth: true,
      value: localizationMaps.fromEnglish('yesOrNo', data.setMaxPooledRollover),
      variant: "outlined",
      error: errors.setMaxPooledRollover,
      onChange: e => this._handleChange("setMaxPooledRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      onBlur: e => this._saveInGlobalState("setMaxPooledRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.yesOrNo()
    })), data.setMaxPooledRollover === 'Yes' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.healthSpendingRolloverMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.maxHsaRollover,
      onChange: e => this._handleChange("maxHsaRollover", e.target.value),
      onBlur: e => this._saveInGlobalState("maxHsaRollover", e.target.value),
      error: errors.maxHsaRollover,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.lifestyleSpendingRolloverMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.maxLsaRollover,
      onChange: e => this._handleChange("maxLsaRollover", e.target.value),
      onBlur: e => this._saveInGlobalState("maxLsaRollover", e.target.value),
      error: errors.maxLsaRollover,
      variant: "outlined"
    })))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectItemsToInclude)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.spendingAccounts.healthSpendingAccount),
      isSelected: data.includeHsa,
      onClick: () => this._saveInGlobalState("includeHsa", !data.includeHsa)
    }))), data.includeHsa && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.spendingAccounts.healthSpendingMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.hsaAmount,
      onChange: e => this._handleChange("hsaAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("hsaAmount", e.target.value),
      error: errors.hsaAmount,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.allow1YearRollover),
      fullWidth: true,
      value: localizationMaps.fromEnglish('yesOrNo', data.allowHsaRollover),
      variant: "outlined",
      error: errors.allowHsaRollover,
      onChange: e => this._handleChange("allowHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      onBlur: e => this._saveInGlobalState("allowHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.yesOrNo()
    })), data.allowHsaRollover === 'Yes' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.setRolloverMaximum),
      fullWidth: true,
      value: localizationMaps.fromEnglish('yesOrNo', data.setMaxHsaRollover),
      variant: "outlined",
      error: errors.setMaxHsaRollover,
      onChange: e => this._handleChange("setMaxHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      onBlur: e => this._saveInGlobalState("setMaxHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.yesOrNo()
    })), data.setMaxHsaRollover === 'Yes' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.healthSpendingRolloverMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.maxHsaRollover,
      onChange: e => this._handleChange("maxHsaRollover", e.target.value),
      onBlur: e => this._saveInGlobalState("maxHsaRollover", e.target.value),
      error: errors.maxHsaRollover,
      variant: "outlined"
    })))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.spendingAccounts.lifestyleSpendingAccount),
      isSelected: data.includeLsa,
      onClick: () => this._saveInGlobalState("includeLsa", !data.includeLsa)
    }))), data.includeLsa && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.spendingAccounts.lifestyleSpendingMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.lsaAmount,
      onChange: e => this._handleChange("lsaAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("lsaAmount", e.target.value),
      error: errors.lsaAmount,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.allow1YearRollover),
      fullWidth: true,
      value: localizationMaps.fromEnglish('yesOrNo', data.allowLsaRollover),
      variant: "outlined",
      error: errors.allowLsaRollover,
      onChange: e => this._handleChange("allowLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      onBlur: e => this._saveInGlobalState("allowLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.yesOrNo()
    })), data.allowLsaRollover === 'Yes' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.setRolloverMaximum),
      fullWidth: true,
      value: localizationMaps.fromEnglish('yesOrNo', data.setMaxLsaRollover),
      variant: "outlined",
      error: errors.setMaxLsaRollover,
      onChange: e => this._handleChange("setMaxLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      onBlur: e => this._saveInGlobalState("setMaxLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.yesOrNo()
    })), data.setMaxLsaRollover === 'Yes' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.lifestyleSpendingRolloverMaximum),
      fullWidth: true,
      prefix: "$ ",
      value: data.maxLsaRollover,
      onChange: e => this._handleChange("maxLsaRollover", e.target.value),
      onBlur: e => this._saveInGlobalState("maxLsaRollover", e.target.value),
      error: errors.maxLsaRollover,
      variant: "outlined"
    }))))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.enableProrating)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.buttons.yes),
        selected: data.isProrated === true,
        field: 'isPooled'
      },
      second: {
        title: i18n.t(tokens.buttons.no),
        selected: data.isProrated === false,
        field: 'isPooled'
      },
      handleChange: () => this._saveInGlobalState('isProrated', !data.isProrated)
    }), data.isProrated && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.typeOfProration)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.planDesign.day),
        selected: data.proratedBy === 'day',
        field: 'day'
      },
      second: {
        title: i18n.t(tokens.labels.planDesign.month),
        selected: data.proratedBy === 'month',
        field: 'month'
      },
      third: {
        title: i18n.t(tokens.labels.planDesign.quarter),
        selected: data.proratedBy === 'quarter',
        field: 'quarter'
      },
      handleChange: (field, value) => this._saveInGlobalState('proratedBy', field),
      whitelabel: this.props.whitelabel
    })), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.enableQuarterlyAllowance)), /*#__PURE__*/React.createElement(Text, {
      tiny: true
    }, i18n.t(tokens.labels.planDesign.noteQuarterlyAllowance)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.buttons.yes),
        selected: data.isQuarterlyAllowance === true,
        field: 'isQuarterlyAllowance'
      },
      second: {
        title: i18n.t(tokens.buttons.no),
        selected: data.isQuarterlyAllowance === false,
        field: 'isQuarterlyAllowance'
      },
      handleChange: () => this._saveInGlobalState('isQuarterlyAllowance', !data.isQuarterlyAllowance),
      disabled: data.isProrated === true
    }), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "20px 0 10px 0"
    }, i18n.t(tokens.labels.planDesign.planEligibilityTermination)), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.eligibilityPeriodMonths),
      fullWidth: true,
      value: data.eligibilityPeriod,
      variant: "outlined",
      onChange: e => this._handleChange("eligibilityPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("eligibilityPeriod", e.target.value),
      error: errors.eligibilityPeriod
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.minimumHoursPerWeek),
      fullWidth: true,
      value: data.minHoursPerWeek,
      variant: "outlined",
      onChange: e => this._handleChange("minHoursPerWeek", e.target.value),
      onBlur: e => this._saveInGlobalState("minHoursPerWeek", e.target.value),
      error: errors.minHoursPerWeek
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.terminationAge),
      fullWidth: true,
      value: data.terminationAge,
      onChange: e => this._handleChange("terminationAge", e.target.value),
      onBlur: e => this._saveInGlobalState("terminationAge", e.target.value),
      error: errors.terminationAge,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true
    }, "Notes:"), /*#__PURE__*/React.createElement(TextInput, {
      fullWidth: true,
      value: data.notes || '',
      variant: "outlined",
      error: errors.notes,
      onChange: e => this._handleChange("notes", e.target.value),
      onBlur: e => this._saveInGlobalState("notes", e.target.value),
      multiline: true,
      rows: 5,
      placeholder: i18n.t(tokens.labels.planDesign.additionalRequestsInformation)
    })));
  }
}
export default SpendingAccounts;